module.exports = __webpack_public_path__ + "assets/img/246301.dc602a83.svg";